import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IconsList from '../molecules/IconsList';

class MYBOOKINGTEST extends React.Component {
  render() {
    return (
      <div className="flex mt-8 relative z-10">
             <IconsList/>

      </div>
    );
  }
}

// MYBOOKINGTEST.contextTypes = {
//   t: PropTypes.func.isRequired,
// };

// export default MYBOOKINGTEST;
// // export default connect(state => (
// //     console.log(state)
// // ))(MYBOOKINGTEST);

MYBOOKINGTEST.propTypes = {
  showThanks: PropTypes.bool,
};

MYBOOKINGTEST.defaultProps = {
  showThanks: false,
};

MYBOOKINGTEST.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect((state) => ({
  locator: state.booking.book_locator,
  email: state.booking.book_email,
  booking: state.booking.bookData,
  lang: state.i18nState.lang,
  device: state.booking.device,
  utmParams: state.bookingFormState.utmParams || {},
  chain: state.bookingFormState.chain,
  // isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  chainData: state.session.chainData,
}))(MYBOOKINGTEST);
